export default __webpack_public_path__ + "static/media/Factsheet.053c5540.svg";